import { useTranslation } from "react-i18next";
import * as amplitude from '@amplitude/analytics-browser';
import { subDays } from 'date-fns';

import { Modal } from "@unified-checkout/design-system";
import {
  ArrowUpRight,
  Crown,
} from "@unified-checkout/design-system/icons/index";

import {
  PAYMOB_PRO_EVENTS,
  PAYMOB_PRO_EVENTS_PARAMS,
  PAYMOB_PRO_VALUES
} from "@app/dashboard/constants/tracking_events/paymob-pro";
import {
  PAYMOB_PRO_URL,
  REMINDER_DAYS_BEFORE
} from "@app/dashboard/constants/paymob-pro";
import type { IPaymobProTrialDates } from "@app/dashboard/types/innerLayout/paymob_pro/paymob-pro";
import { formatDateRangeUTC } from "@app/dashboard/utils/dateFormats";
import styles from "./trial-confirmation-modal.module.scss";

export const TrialConfirmationModal = ({
  isConfirmationModalOpen,
  setIsConfirmationModalOpen,
  setIsPaymobProDrawerOpen,
  onAdvisorClickHandler,
  trialDates
}: {
  isConfirmationModalOpen: boolean;
  setIsConfirmationModalOpen: (open: boolean) => void;
  setIsPaymobProDrawerOpen: (open: boolean) => void;
  onAdvisorClickHandler: () => void;
  trialDates: IPaymobProTrialDates | null;
}) => {
  const { t } = useTranslation();

  const getModalText = () => {
    if (!trialDates) return '';

    const planStartDate = formatDateRangeUTC(new Date(trialDates.end_date), 'long');
    const reminderDate = formatDateRangeUTC(
      subDays(new Date(trialDates.end_date), REMINDER_DAYS_BEFORE),
      'long'
    );

    return t('innerLayout.paymobPro.modalText')
      .replace('{{planStartDate}}', planStartDate)
      .replace('{{reminderDate}}', reminderDate);
  };


  const handleOpenPaymobProClick = () => {
    onAdvisorClickHandler();
    window.open(PAYMOB_PRO_URL, '_blank');

    amplitude.track(PAYMOB_PRO_EVENTS.OPEN_PAYMOB_ADVISOR_CLICKED, {
      [PAYMOB_PRO_EVENTS_PARAMS.SUBSCRIBED_TRAIL_PLAN]: PAYMOB_PRO_VALUES.TRIAL,
    });

    setIsConfirmationModalOpen(false);
    setIsPaymobProDrawerOpen(false);
  };

  const handleCloseClick = () => {
    setIsConfirmationModalOpen(false);
    setIsPaymobProDrawerOpen(false);
  };

  const btnProps = [
    {
      text: t('innerLayout.paymobPro.modalBtn1'),
      variant: "contained" as const,
      color: "primary" as const,
      trailingIcon: ArrowUpRight,
      size: "md" as const,
      onClickHandler: handleOpenPaymobProClick,
    },
    {
      text: t('innerLayout.paymobPro.modalBtn2'),
      variant: "outlined" as const,
      color: "secondary" as const,
      size: "md" as const,
      onClickHandler: handleCloseClick,
    }
  ]

  return (
    <Modal
      open={isConfirmationModalOpen}
      state="primary"
      position="center"
      headerIcon={Crown}
      closeOnClickOutside={false}
      onCloseHandler={() => setIsConfirmationModalOpen(false)}
      title={t('innerLayout.paymobPro.modalTitle')}
      supportingText={t('innerLayout.paymobPro.modalSupportingText')}
      hasCloseIcon

      btnsProps={btnProps}
    >
      <div className={styles['confirmation-modal']}>
        <div className={styles['confirmation-modal__text']}>
          {getModalText()}
        </div>
      </div>
    </Modal>
  );
};
